/* eslint-disable yoda */

/**
 * Formats a raw API image response for use in the uploader.
 * @param {Array} rawImages An array of raw image objects from the API.
 * @returns {Array} A new array with properties formatted for the MediaCard component.
 */
export const formatMediaForUploader = (rawMedia = {}) => {
  const isEmbed = rawMedia?.embed_type === 'video' || rawMedia?.embed_type === '3d';
  const baseType = rawMedia.embed_type ?? '';
  return ({
    id: rawMedia?.id || rawMedia?._id,
    imageUrl: rawMedia?.thumbnail_url || rawMedia?.url,
    type: rawMedia?.sort_order === 1 && !isEmbed ? 'cover' : baseType,
    altText: rawMedia?.title || '',
    sortOrder: rawMedia?.sort_order
  });
};

/**
 * Checks if the media item is from YouTube and optimizes the thumbnail URL
 * to ensure a standard medium-quality version is used.
 * @param {object} item The media embed item object (must contain provider_name and thumbnail_url).
 * @returns {string | undefined} The optimized thumbnail URL, or the original URL if not YouTube.
 */
export const getOptimizedThumbnailUrl = (item) => {
  let thumbnailUrl = item.thumbnail_url;

  if (item.provider_name === 'youtube' && thumbnailUrl) {
    thumbnailUrl = thumbnailUrl.replace(/\/hqdefault\.jpg$/, '') + '/mqdefault.jpg';
  }
  return thumbnailUrl;
};
